<section class="penalty">

  <div class="penalite" mat-dialog-content>
    <div class="calledOn">
      <app-sous-titre-bloc>
        {{ 'components.penalty.penaltyFor' | transloco }}
      </app-sous-titre-bloc>
      <!--  (on recule)-->
      <app-button-toggle-group>
        <mat-button-toggle-group class="button-toggle-group-small flex flex-col sm:flex-row">
          <mat-button-toggle
            data-testid="penaltyForHome"
            [checked]="true"
            (click)="setPenaltyForHome()" class="w-full sm:w-1/2 button-toggle-small">
            {{ 'components.penalty.home' | transloco }} - {{ game.game.homeTeam.teamShortName }}
          </mat-button-toggle>
          <mat-button-toggle
            data-testid="penaltyForAway"
            (click)="setPenaltyForAway()" class="w-full sm:w-1/2 button-toggle-small">
            {{ 'components.penalty.away' | transloco }} - {{ game.game.awayTeam.teamShortName }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </app-button-toggle-group>
    </div>

    @if (dataPenalty.penaltyType !== PenaltyType.AfterPlay) {
      <div>
        <app-sous-titre-bloc>
          {{ 'components.penalty.resultingDown' | transloco }}
        </app-sous-titre-bloc>
        <app-button-toggle-group>
          <mat-button-toggle-group aria-label="repeatLastDown" class="flex flex-col sm:flex-row button-toggle-group-small"
            #group="matButtonToggleGroup">
            <mat-button-toggle (click)="repeatLastDown()"
              [checked]="resultingDown === 'repeatLastDown'"
              data-testid="repeatLastDown"
              class="w-full sm:w-1/2 petit-texte sm-pad toggle-btn">
              {{ 'components.penalty.repeatLastDown' | transloco }}
            </mat-button-toggle>
            <mat-button-toggle (click)="firstDown()"
              [checked]="resultingDown === 'firstDown'"
              data-testid="firstDown"
              class="w-full sm:w-1/2 petit-texte sm-pad toggle-btn">
              {{ 'components.penalty.firstDown' | transloco }}
            </mat-button-toggle>
            <mat-button-toggle (click)="loosDown()"
              [checked]="resultingDown === 'loosDown'"
              data-testid="loosDown"
              class="w-full sm:w-1/2 petit-texte sm-pad toggle-btn">
              {{ 'components.penalty.loosDown' | transloco }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </app-button-toggle-group>
      </div>
    }

    <div class="penalty-yardage">
      <div>
        <app-sous-titre-bloc>
          {{ 'components.penalty.penaltyYardage' | transloco }}
        </app-sous-titre-bloc>
        <div class="buttons">
          <button mat-flat-button data-testid="yard5"
            (click)="selectYard(5)">{{ 'components.penalty.yard5' | transloco }}
          </button>
          <button mat-flat-button data-testid="yard10"
            (click)="selectYard(10)">{{ 'components.penalty.yard10' | transloco }}
          </button>
          <button mat-flat-button data-testid="yard15"
            (click)="selectYard(15)">{{ 'components.penalty.yard15' | transloco }}
          </button>
          <button mat-flat-button
            [disabled]="isHalfTheDistanceDisabled()"
            data-testid="halfTheDistance"
            (click)="selectHalfTheDistance()">{{ 'components.penalty.halfTheDistance' | transloco }}
          </button>
        </div>
      </div>
      <div>
        <div class="wheels">
          <div class="spot-the-ball">
            <app-wheel-selector #wheelSelector
              data-testid="penaltySpot"
              [homeHasPossession]="game.homeHasPossession()"
              [title]="title"
              [data]="data"
              (changeValue)="change($event)">
            </app-wheel-selector>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="flex flex-row flex-wrap w-full h-full justify-center">
      <div class="w-full sm:w-1/5">
        <button class="secondary-result-btn" data-testid="cancelPenalty" (click)="cancel()"
          style="border-width: 1px;">
          {{ 'components.penalty.cancel' | transloco  }}
        </button>
      </div>
      <div class="w-full sm:w-1/5">
        <button class="secondary-result-btn" data-testid="savePenalty" (click)="save()"
          style="background: #02b7e6; border-width: 1px;">
          <span style="color: black;">{{ 'components.penalty.save' | transloco }}</span>
        </button>
      </div>
    </div>
  </div>
</section>
